module.exports = __webpack_public_path__ + "images/null-training-space.4365a10810bc57ae709573ae74af4951.png";